/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendFormDocumentRequest
 */
export interface SendFormDocumentRequest {
    /**
     * Template ID to send
     * @type {number}
     * @memberof SendFormDocumentRequest
     */
    formTemplateId: number;
    /**
     * Homeowner name
     * @type {string}
     * @memberof SendFormDocumentRequest
     */
    recipientName: string;
    /**
     * Homeowner email
     * @type {string}
     * @memberof SendFormDocumentRequest
     */
    recipientEmail: string;
}

/**
 * Check if a given object implements the SendFormDocumentRequest interface.
 */
export function instanceOfSendFormDocumentRequest(value: object): value is SendFormDocumentRequest {
    if (!('formTemplateId' in value) || value['formTemplateId'] === undefined) return false;
    if (!('recipientName' in value) || value['recipientName'] === undefined) return false;
    if (!('recipientEmail' in value) || value['recipientEmail'] === undefined) return false;
    return true;
}

export function SendFormDocumentRequestFromJSON(json: any): SendFormDocumentRequest {
    return SendFormDocumentRequestFromJSONTyped(json, false);
}

export function SendFormDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendFormDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'formTemplateId': json['formTemplateId'],
        'recipientName': json['recipientName'],
        'recipientEmail': json['recipientEmail'],
    };
}

export function SendFormDocumentRequestToJSON(json: any): SendFormDocumentRequest {
    return SendFormDocumentRequestToJSONTyped(json, false);
}

export function SendFormDocumentRequestToJSONTyped(value?: SendFormDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'formTemplateId': value['formTemplateId'],
        'recipientName': value['recipientName'],
        'recipientEmail': value['recipientEmail'],
    };
}

